export enum StarzleBallColor {
    RED = 'red',
    BLUE = 'blue',
    WHITE = 'white',
    EMPTY = 'empty',
}
